import { getAbbreviationByProperty } from '@swegon-core/swegon.conversions.javascript';
import { LANGUAGES, UNIT_SYSTEM } from '../../../lib/constants.js';

export const getAbbreviationForUnitSystem = typeOfUnitSystem => propertyName => {
    if (!propertyName) return;

    const locale = typeOfUnitSystem === UNIT_SYSTEM.METRIC ? LANGUAGES.SE : LANGUAGES.US;
    return getAbbreviationByProperty(propertyName, locale);
};
